import styled from "styled-components";

export const UterumImageContainer = styled.div`
  text-align: center;
  width: 100%;
  display: block;
  position: relative;
  height: 240px;

  @media (min-width: 480px) {
    width: 50%;
    min-height: 130px;
  }

  @media (min-width: 900px) {
    width: 30%;
  }
`;

export const UterumImage = styled.img`
  position: absolute;
  width: 100%;
  left: 0;
`;

export const SketchContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  background: white;
  flex-direction: column;
  padding: 10px;
  justify-content: space-between;

  @media (min-width: 480px) {
    flex-direction: row;
  }
`;
